window.onload = function(){
  var linkmsg=document.getElementById("linkmsg");
  linkmsg.innerHTML="";
  linkmsg.style.visibility="hidden";
  sizemsg.style.visibility="hidden";
  opmsg.style.visibility="hidden";
//棚板枚数取得
    var idBoard = document.getElementsByName("shelfboard") ;
    var strBoard = "";
    for ( strBoard="", c=idBoard.length; c--; ) {
     if ( idBoard[c].checked ) {
      strBoard = idBoard[c].id ;
      break ;
     }
    }
  if(strBoard=="selectboard1"){
  document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/zeroxt-size1.png?v=1643469228";
  shelfboard1.style.visibility="visible";
  shelfboard2.style.visibility="hidden";
  document.getElementById("message").innerHTML = "<p>幅60～180cm・奥行30～45cm・高さ37～120cmまで1cm単位でオーダー可能です。<br>棚板内寸は、高さから天板と棚板の厚み合計8cmを引いた高さまで入力可能です</p>";
  }else if(strBoard=="selectboard2"){
  document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/zeroxt-size2.png?v=1643469540";
  shelfboard1.style.visibility="visible";
  shelfboard2.style.visibility="visible";
  document.getElementById("message").innerHTML = "<p>幅60～180cm・奥行30～45cm・高さ37～120cmまで1cm単位でオーダー可能です。<br>棚板内寸は、高さから天板と棚板の厚み合計12cmを引いた高さまで入力可能です</p>";
  }else if(strBoard=="selectboard0"){
  document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/zeroxt-size0.png?v=1643469540";
  shelfboard1.style.visibility="hidden";
  shelfboard2.style.visibility="hidden";
  document.getElementById("message").innerHTML = "<p>幅60～150cm・奥行30～45cm・高さ37～120cmまで1cm単位でオーダー可能です。</p>";
  }

}

//オプション
function changeOp(){
    checkBoxbk = document.frm_detail.op_casterbk.checked;
    checkBoxwh = document.frm_detail.op_casterwh.checked;
    opmsg.style.visibility="hidden";
    if (checkBoxbk==true&&checkBoxwh==true){
        document.getElementById("opmsg").innerHTML = "<p>※本体の高さに約5.2cmプラスとなります</p><p>※奥行41cm以上の場合、キャスター数は6つになります</p><p><span>ブラックとホワイトが選択されています</span></p>";
     opmsg.style.visibility="visible";
        cartReset();
        return false;
    }
    if (checkBoxbk==true||checkBoxwh==true){
        document.getElementById("opmsg").innerHTML = "<p>※本体の高さに約5.2cmプラスとなります</p><p>※奥行41cm以上の場合、キャスター数は6つになります</p>";
     opmsg.style.visibility="visible";
        cartReset();
        return false;
    }
    opmsg.style.visibility="hidden";
    cartReset();
}

//カート中身リセット
function cartReset(){
  document.getElementById("price").value=""
  cart_price.innerHTML =""+" 円";
  cart_haba.innerHTML=""; 
  cart_depth.innerHTML=""; 
  cart_height.innerHTML="";
  cart_number.innerHTML="";
  cart_board1.innerHTML="";
  cart_board2.innerHTML="";
  cart_color.innerHTML="";
  cart_option.innerHTML="";
  additional_fee.innerHTML="";
  linkmsg.style.visibility="hidden";
}

// 棚板画像・入力欄変更
function showimg1(){
  document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/zeroxt-size1.png?v=1643469228";
  shelfboard1.style.visibility="visible";
  shelfboard2.style.visibility="hidden";
  document.getElementById("message").innerHTML = "<p>幅60～180cm・奥行30～45cm・高さ37～120cmまで1cm単位でオーダー可能です。<br>棚板内寸は、高さから天板と棚板の厚み合計8cmを引いた高さまで入力可能です</p>";
  cartReset();
    changeMsg();//20191122追加
}
function showimg2(){
  document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/zeroxt-size2.png?v=1643469540";
  shelfboard1.style.visibility="visible";
  shelfboard2.style.visibility="visible";
  document.getElementById("message").innerHTML = "<p>幅60～180cm・奥行30～45cm・高さ37～120cmまで1cm単位でオーダー可能です。<br>棚板内寸は、高さから天板と棚板の厚み合計12cmを引いた高さまで入力可能です</p>";
  cartReset();
    changeMsg();//20191122追加
}
function showimg3(){
  document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/zeroxt-size0.png?v=1643469540";
  shelfboard1.style.visibility="hidden";
  shelfboard2.style.visibility="hidden";
  document.getElementById("message").innerHTML = "<p>幅60～150cm・奥行30～45cm・高さ37～120cmまで1cm単位でオーダー可能です。</p>";
  cartReset();
    changeMsg();//20191122追加
}



//リアルタイムサイズチェック
function changeMsg(){
    var intDepth=document.getElementById("depth").value;
    var intHaba=document.getElementById("haba").value;
    var intHeight=document.getElementById("height").value;
    var intBoard1=document.getElementById("board1").value;
    var intBoard2=document.getElementById("board2").value; 
    sizemsg.style.visibility="hidden";
//棚板枚数取得
    var idBoard = document.getElementsByName("shelfboard") ;
    var strBoard = "";
    for ( strBoard="", c=idBoard.length; c--; ) {
     if ( idBoard[c].checked ) {
      strBoard = idBoard[c].id ;
      break ;
     }
    }
    cartReset();
    if (intDepth==""||intHaba==""||intHeight==""){
        document.getElementById("sizemsg").innerHTML = "<p> </p>";
  sizemsg.style.visibility="hidden";
        return false;
    }
//棚板1枚の場合
    if (strBoard == "selectboard1" ){
  var insideBoard1=intHeight-8;
  if (insideBoard1 < intBoard1){document.getElementById("sizemsg").innerHTML = "<p>※ 棚板内寸は"+insideBoard1+"cm以内で入力してください ※</p>";sizemsg.style.visibility="visible";document.getElementById("price").value="";return false;}
    }
  if (strBoard == "selectboard1"&&intBoard1=="0"){document.getElementById("sizemsg").innerHTML = "<p>※ 棚板内寸を入力してください ※</p>";sizemsg.style.visibility="visible";document.getElementById("price").value="";return false;}
//棚板2枚の場合
    if (strBoard == "selectboard2" ){
  var insideBoard1;
  var insideBoard2;
  insideBoard1=intHeight-12;

  //【1】【2】に入力があったら
  if(intBoard1 != ""&&intBoard2 != ""){
      insideBoard1=intHeight-intBoard1-12;
      insideBoard2=insideBoard1-intBoard2;
      var a = Math.sign(insideBoard1);
      var b = Math.sign(intHeight-intBoard2-12);

      if(a==-1||b==-1){document.getElementById("sizemsg").innerHTML = "<p>※ 棚板内寸の見直しをお願い致します ※</p>";sizemsg.style.visibility="visible";document.getElementById("price").value="";return false;}
      if (insideBoard1 < intBoard2){document.getElementById("sizemsg").innerHTML = "<p>※ 棚板内寸（2）は"+insideBoard1+"cm以内で入力してください ※</p>";sizemsg.style.visibility="visible";document.getElementById("price").value="";return false;}
  }


  //【1】に入力があったら
  if(intBoard1 != ""){
  var insideBoard1=intHeight-12;
      if (insideBoard1 < intBoard1){document.getElementById("sizemsg").innerHTML = "<p>※ 棚板内寸（1）は"+insideBoard1+"cm以内で入力してください ※</p>";sizemsg.style.visibility="visible";document.getElementById("price").value="";return false;}
  }
  //【2】に入力があったら
  if(intBoard2 != ""){
  var insideBoard1=intHeight-12;
      if (insideBoard1 < intBoard2){document.getElementById("sizemsg").innerHTML = "<p>※ 棚板内寸（2）は"+insideBoard1+"cm以内で入力してください ※</p>";sizemsg.style.visibility="visible";document.getElementById("price").value="";return false;}
  }
  if (strBoard == "selectboard2"&&intBoard1=="0"){document.getElementById("sizemsg").innerHTML = "<p>※ 棚板内寸を入力してください ※</p>";sizemsg.style.visibility="visible";document.getElementById("price").value="";return false;}
  if (strBoard == "selectboard2"&&intBoard2=="0"){document.getElementById("sizemsg").innerHTML = "<p>※ 棚板内寸を入力してください ※</p>";sizemsg.style.visibility="visible";document.getElementById("price").value="";return false;}

    }
    if (intHaba < 60 || intHaba > 180){document.getElementById("sizemsg").innerHTML = "<p>※ 幅60cm未満・幅181cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";document.getElementById("price").value="";return false;}
    if (intDepth < 30 || intDepth > 45){document.getElementById("sizemsg").innerHTML = "<p>※ 奥行30cm未満・奥行46cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";document.getElementById("price").value="";return false;}
    if (intHeight < 37 || intHeight > 120){document.getElementById("sizemsg").innerHTML = "<p>※ 高さ37cm未満・高さ121cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";document.getElementById("price").value="";return false;}//20240527ZERO-XTの既存オプションの巾木避けは高さ40cm～しか対応ができないため
    if(intHaba > 150 && strBoard == "selectboard0"){document.getElementById("sizemsg").innerHTML = "<p>※ 棚板なしの幅151cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";document.getElementById("price").value="";return false;}
        document.getElementById("sizemsg").innerHTML = "<p> </p>"
  sizemsg.style.visibility="hidden";
    //棚板0枚の場合　20191122追加
    if(strBoard == "selectboard0"){
        if(intHeight > 89){document.getElementById("sizemsg").innerHTML = "<p>※ 棚板なしの高さ90cm以上をご希望の場合は、ボンドでの固定と壁付けにて設置でのご使用をお願いいたします ※</p>";sizemsg.style.visibility="visible";}
    }
}


// Zero-XT サイズオーダー
const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_top\">→こちらのページよりお買い求めください。</a>"


function setGoods(url,haba,depth,height,thick,color,board1,board2,price){
this.url=url;this.haba=haba;this.depth=depth;this.height=height;this.thick=thick;this.color=color;this.board1=board1;this.board2=board2;this.price=price;}
function searchURL(strHaba,strDepth,strHeight,strThick,strColor,numBoard1,numBoard2){
var strErr;
var intDepth=document.getElementById("depth").value
var intHaba=document.getElementById("haba").value
var intHeight=document.getElementById("height").value


//幅チェック
if (intHaba < 60){strErr="幅60cm未満";}
else if (intHaba > 180){
  strErr="幅181cm以上";}
if(strErr){document.getElementById("price").value="";
return strErr+"はオーダー不可です。";}


//幅サイズ成形
switch(strHaba.length){
  case 2:
    if(strHaba.slice(0,1)=="9" && strHaba.slice(-1)!="0"){
      strHaba ="100";
    }else if(strHaba.slice(-1) !="0"){
      strHaba=parseInt(strHaba.slice(0,1))+1+"0";
    }else{
      
    }
    break;
  case 3:
    if(strHaba.slice(-1)=="0"){
      
    }else{
    strHaba=strHaba.slice(0,1)+parseInt(parseInt(strHaba.slice(1,2))+1)+"0";
    }
    break;
}
//高さサイズ成形
switch(strHeight.length){
  case 2:
    if(strHeight.slice(0,1)=="9" && strHeight.slice(-1)!="0"){
      strHeight ="100";
    }else if(strHeight.slice(-1) !="0"){
      strHeight=parseInt(strHeight.slice(0,1))+1+"0";
    }else{
      
    }
    break;
  case 3:
    if(strHeight.slice(-1)=="0"){
      
    }else{
    strHeight=strHeight.slice(0,1)+parseInt(parseInt(strHeight.slice(1,2))+1)+"0";
    }
    break;
}



// ベース価格
var mulHaba;
var mulHeight;
var mulHeight2;
var mulHeight3;
var mulHeight4;
var sellPrice;
var i = 0;

var boardPrice = [6000,17000,20000,23000,28000];
mulHaba = (parseInt(strHaba) - 60) / 10;
mulHeight = (parseInt(strHeight) - 30) / 10;
mulHeight2 = (parseInt(strHeight) - 90) / 10;
mulHeight3 = (parseInt(strHeight) - 70) / 10;
mulHeight4 = (parseInt(strHeight) - 60) / 10;

// 📌 CSVを配列に変換する関数
function csvToArray(filename) {
    var request = new XMLHttpRequest();
    request.open("GET", filename, false);
    try {
        request.send(null);
    } catch (err) {
        console.error("Error fetching CSV:", err);
        return [];
    }
    
    var csvArr = [];
    var lines = request.responseText.split("\n");
    for (var i = 0; i < lines.length; ++i) {
        var cells = lines[i].split(",");
        if (cells.length > 1) {
            csvArr.push(cells.map(cell => parseInt(cell.trim(), 10) || 0)); // 余分な空白を削除＆整数変換
        }
    }
    return csvArr;
}

// 📌 CSVデータから価格を取得する関数
function getPrice(strColor, strHaba, strHeight) {
    let filePath = "";
    let rowOffset = 0; // **行オフセットを追加（zeroxt-mela.csv で特定行から取得する処理）**

    // 📌 CSVファイルを選択
    if (strColor === "wood") {
        filePath = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/zeroxt-wood.csv?v=1737336514";
    } else if (["nail", "black"].includes(strColor)) {
        filePath = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/zeroxt-mela.csv?v=1737336515";
    } else if (strColor === "bp") {
        filePath = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/zeroxt-mela.csv?v=1737336515";
        rowOffset = 13; // **A14行目からデータ取得**
    } else if (["mb", "gs", "ww"].includes(strColor)) {
        filePath = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/zeroxt-mela.csv?v=1737336515";
        rowOffset = 26; // **A27行目からデータ取得**
    } else if (strColor === "kme") {
        filePath = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/zeroxt-wil.csv?v=1737336514";
    }

    if (!filePath) {
        console.error("該当するCSVファイルがありません");
        return null;
    }

    // 📌 CSVデータを取得
    var csvData = csvToArray(filePath);
    if (csvData.length === 0) {
        console.error("CSVの読み込みに失敗しました");
        return null;
    }

    // 📌 幅リスト & 高さリストを取得
    const widthList = Array.from({ length: 13 }, (_, i) => 60 + i * 10);  // 60～180
    const heightList = Array.from({ length: 10 }, (_, i) => 30 + i * 10); // 30～120

    console.log("📌 CSVデータを取得:", csvData);
    console.log("幅リスト:", widthList);
    console.log("高さリスト:", heightList);

    // 📌 幅・高さを最も近い値に補正
    const roundedWidth = roundUp(parseInt(strHaba, 10), widthList, 180);
    const roundedHeight = roundUp(parseInt(strHeight, 10), heightList, 120);

    console.log("入力幅:", strHaba, " -> 丸めた幅:", roundedWidth);
    console.log("入力高さ:", strHeight, " -> 丸めた高さ:", roundedHeight);

    // 📌 幅と高さに該当する価格を取得
    const rowIndex = widthList.indexOf(roundedWidth);
    const colIndex = heightList.indexOf(roundedHeight);

    console.log("算出された行インデックス:", rowIndex);
    console.log("算出された列インデックス:", colIndex);

    if (rowIndex !== -1 && colIndex !== -1) {
        const adjustedRowIndex = rowIndex + rowOffset; // **オフセットを適用**
        if (adjustedRowIndex < csvData.length) {
            const price = csvData[adjustedRowIndex][colIndex];
            console.log("該当する価格:", price);
            return price;
        }
    } 

    console.error("該当する価格が見つかりません");
    return null;
}

// 📌 幅と高さの値を最も近い大きい値に丸める（上限あり）
function roundUp(value, list, maxLimit) {
    for (let i = 0; i < list.length; i++) {
        if (value <= list[i]) return list[i];
    }
    return maxLimit;
}


// ノーマル価格
sellPrice = getPrice(strColor, strHaba, strHeight);


//棚板枚数取得
    var idBoard = document.getElementsByName("shelfboard") ;
    var strBoard = "";
    for ( strBoard="", c=idBoard.length; c--; ) {
     if ( idBoard[c].checked ) {
      strBoard = idBoard[c].id ;
      break ;
     }
    }
if(strColor=="wood"){
  //高さ90未満かつ幅80以下かつ棚板0枚
  if(strHeight < 90 && strHaba <= 80 && strBoard == "selectboard0" ){
    sellPrice = sellPrice - 5000;
    return sellPrice;
  }
  //高さ90未満かつ幅80以下かつ棚板2枚
  if(strHeight < 90 && strHaba <= 80 && strBoard == "selectboard2" ){
    sellPrice = sellPrice + 6000;
    return sellPrice;
  }
  //高さ90以上かつ幅80以下かつ棚板0枚
  if(strHeight >= 90 && strHaba <= 80 && strBoard == "selectboard0" ){
    sellPrice = sellPrice - 10000;
    return sellPrice;
  }
  //高さ90以上かつ幅80以下かつ棚板1枚
  if(strHeight >= 90 && strHaba <= 80 && strBoard == "selectboard1" ){
    sellPrice = sellPrice - 5000;
    return sellPrice;
  }


  //高さ90未満かつ幅81以上100以下かつ棚板0枚
  if(strHeight < 90 && strHaba <= 100 && strBoard == "selectboard0" ){
    sellPrice = sellPrice - 6000;
    return sellPrice;
  }
  //高さ90未満かつ幅81以上100以下かつ棚板2枚
  if(strHeight < 90 && strHaba <= 100 && strBoard == "selectboard2" ){
    sellPrice = sellPrice + 8000;
    return sellPrice;
  }
  //高さ90以上かつ幅81以上100以下かつ棚板0枚
  if(strHeight >= 90 && strHaba <= 100 && strBoard == "selectboard0" ){
    sellPrice = sellPrice - 12000;
    return sellPrice;
  }
  //高さ90以上かつ幅81以上100以下かつ棚板1枚
  if(strHeight >= 90 && strHaba <= 100 && strBoard == "selectboard1" ){
    sellPrice = sellPrice - 6000;
    return sellPrice;
  }


  //高さ90未満かつ幅101以上120以下かつ棚板0枚
  if(strHeight < 90 && strHaba <= 120 && strBoard == "selectboard0" ){
    sellPrice = sellPrice - 7000;
    return sellPrice;
  }
  //高さ90未満かつ幅101以上120以下かつ棚板2枚
  if(strHeight < 90 && strHaba <= 120 && strBoard == "selectboard2" ){
    sellPrice = sellPrice + 9000;
    return sellPrice;
  }
  //高さ90以上かつ幅101以上120以下かつ棚板0枚
  if(strHeight >= 90 && strHaba <= 120 && strBoard == "selectboard0" ){
    sellPrice = sellPrice - 14000;
    return sellPrice;
  }
  //高さ90以上かつ幅101以上120以下かつ棚板1枚
  if(strHeight >= 90 && strHaba <= 120 && strBoard == "selectboard1" ){
    sellPrice = sellPrice - 7000;
    return sellPrice;
  }


  //高さ90未満かつ幅121以上140以下かつ棚板0枚
  if(strHeight < 90 && strHaba <= 140 && strBoard == "selectboard0" ){
    sellPrice = sellPrice - 8000;
    return sellPrice;
  }
  //高さ90未満かつ幅121以上140以下かつ棚板2枚
  if(strHeight < 90 && strHaba <= 140 && strBoard == "selectboard2" ){
    sellPrice = sellPrice + 10000;
    return sellPrice;
  }
  //高さ90以上かつ幅121以上140以下かつ棚板0枚
  if(strHeight >= 90 && strHaba <= 140 && strBoard == "selectboard0" ){
    sellPrice = sellPrice - 16000;
    return sellPrice;
  }
  //高さ90以上かつ幅121以上140以下かつ棚板1枚
  if(strHeight >= 90 && strHaba <= 140 && strBoard == "selectboard1" ){
    sellPrice = sellPrice - 8000;
    return sellPrice;
  }


  //高さ90未満かつ幅141以上160以下かつ棚板0枚
  if(strHeight < 90 && strHaba <= 160 && strBoard == "selectboard0" ){
    sellPrice = sellPrice - 9000;
    return sellPrice;
  }
  //高さ90未満かつ幅141以上160以下かつ棚板2枚
  if(strHeight < 90 && strHaba <= 160 && strBoard == "selectboard2" ){
    sellPrice = sellPrice + 12000;
    return sellPrice;
  }
  //高さ90以上かつ幅141以上160以下かつ棚板0枚
  if(strHeight >= 90 && strHaba <= 160 && strBoard == "selectboard0" ){
    sellPrice = sellPrice - 18000;
    return sellPrice;
  }
  //高さ90以上かつ幅141以上160以下かつ棚板1枚
  if(strHeight >= 90 && strHaba <= 160 && strBoard == "selectboard1" ){
    sellPrice = sellPrice - 9000;
    return sellPrice;
  }


  //高さ90未満かつ幅161以上180以下かつ棚板0枚
  if(strHeight < 90 && strHaba <= 180 && strBoard == "selectboard0" ){
    sellPrice = sellPrice - 10000;
    return sellPrice;
  }
  //高さ90未満かつ幅161以上180以下かつ棚板2枚
  if(strHeight < 90 && strHaba <= 180 && strBoard == "selectboard2" ){
    sellPrice = sellPrice + 14000;
    return sellPrice;
  }
  //高さ90以上かつ幅161以上180以下かつ棚板0枚
  if(strHeight >= 90 && strHaba <= 180 && strBoard == "selectboard0" ){
    sellPrice = sellPrice - 20000;
    return sellPrice;
  }
  //高さ90以上かつ幅161以上180以下かつ棚板1枚
  if(strHeight >= 90 && strHaba <= 180 && strBoard == "selectboard1" ){
    sellPrice = sellPrice - 10000;
    return sellPrice;
  }
      return sellPrice;
}


  //メラミン追加
  //高さ90未満かつ棚板0枚
  if(strHeight < 90 && strBoard == "selectboard0" ){
    if(strColor == "nail"||strColor == "black"){sellPrice = sellPrice - boardPrice[i+1];}
    if(strColor == "bp"){sellPrice = sellPrice - boardPrice[i+2];}
    if(strColor == "mb"||strColor == "gs"||strColor == "ww"){sellPrice = sellPrice - boardPrice[i+3];}
    if(strColor == "kme"){sellPrice = sellPrice - boardPrice[i+4];}
    return sellPrice;
  }
  //高さ90未満かつ棚板2枚
  if(strHeight < 90 && strBoard == "selectboard2" ){
    if(strColor == "nail"||strColor == "black"){sellPrice = sellPrice + boardPrice[i+1];}
    if(strColor == "bp"){sellPrice = sellPrice + boardPrice[i+2];}
    if(strColor == "mb"||strColor == "gs"||strColor == "ww"){sellPrice = sellPrice + boardPrice[i+3];}
    if(strColor == "kme"){sellPrice = sellPrice + boardPrice[i+4];}
    return sellPrice;
  }
  //高さ90以上かつ棚板0枚
  if(strHeight >= 90 && strBoard == "selectboard0" ){
    if(strColor == "nail"||strColor == "black"){sellPrice = sellPrice - (boardPrice[i+1]*2);}
    if(strColor == "bp"){sellPrice = sellPrice - (boardPrice[i+2]*2);}
    if(strColor == "mb"||strColor == "gs"||strColor == "ww"){sellPrice = sellPrice - (boardPrice[i+3]*2);}
    if(strColor == "kme"){sellPrice = sellPrice - (boardPrice[i+4]*2);}
    return sellPrice;
  }
  //高さ90以上かつ棚板1枚
  if(strHeight >= 90 && strBoard == "selectboard1" ){
    if(strColor == "nail"||strColor == "black"){sellPrice = sellPrice - boardPrice[i+1];}
    if(strColor == "bp"){sellPrice = sellPrice - boardPrice[i+2];}
    if(strColor == "mb"||strColor == "gs"||strColor == "ww"){sellPrice = sellPrice - boardPrice[i+3];}
    if(strColor == "kme"){sellPrice = sellPrice - boardPrice[i+4];}
    return sellPrice;
  }
    return sellPrice;
}

/*リストから商品URLを取得*/
function checkURL(strHaba,strDepth,strHeight,strThick,strColor,numBoard1,numBoard2){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].color==strColor && goods[i].board1==numBoard1 && goods[i].board2==numBoard2){
return goods[i].url;}}
return false;
}

/*リストから価格を取得(201902追加)*/
function checkPrice(strHaba,strDepth,strHeight,strThick,strColor,numBoard1,numBoard2){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].color==strColor && goods[i].board1==numBoard1 && goods[i].board2==numBoard2){
return goods[i].price;}}
return false;
}


// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
cartReset();
    
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strDepth=document.getElementById("depth").value;
var strHaba=document.getElementById("haba").value;
var strHeight=document.getElementById("height").value;
var strBoardheight1=document.getElementById("board1").value;
var strBoardheight2=document.getElementById("board2").value;
var idOption = document.getElementsByName("option") ;
var idColor = document.getElementsByName("colortype") ;
var idBoard = document.getElementsByName("shelfboard") ;
var strColor = "";
var strBoard = "";
var strThick="40";
var strOption = "";
var i=0;
var c=0;

//カラー取得
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
     if( idColor[i].id.slice(0,4)=="wood" ){
         strColor = idColor[i].id.slice(0,4);
     }else if( idColor[i].id.slice(0,3)=="kme" ){
         strColor = idColor[i].id.slice(0,3);
     }else{
         strColor = idColor[i].id;
     }
  var valueColor = idColor[i].value ;
  break ;
 }
}

//棚板枚数取得
for ( strBoard="", c=idBoard.length; c--; ) {
 if ( idBoard[c].checked ) {
  strBoard = idBoard[c].id ;
  var valueBoard = idBoard[c].value ;
  break ;
 }
}

//オプションチェック
var total = 0;
for ( c = idOption.length; c--; ) {
 if ( idOption[c].checked ) {
     total++;
     if( strOption == "" ) {
         strOption = idOption[c].id;
         var valueOption = idOption[c].value;
     }else if( strOption != "" ) {
         var valueOption = valueOption+"、"+idOption[c].value;
     }
 }
}

 if(total>0){
     total=total*3000;
 }
 
 if(typeof valueOption=== "undefined"){
     valueOption="オプション無し";
 }

if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
if (isNumber(strDepth)==false){
alert("奥行は『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (isNumber(strHeight)==false){
alert("高さは『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (valueBoard=="棚板1枚" && isNumber(strBoardheight1)==false){
alert("棚板内寸は『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (valueBoard=="棚板2枚" && isNumber(strBoardheight2)==false || valueBoard=="棚板2枚" && isNumber(strBoardheight1)==false){
alert("棚板内寸は『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}

if (strColor==false){
alert("カラーを選択してください");
return false;
}

if(valueBoard=="棚板2枚"){
  var numBoard1 = strBoardheight1;
  var numBoard2 = strBoardheight2;
  strBoardheight1 = strBoardheight1+"cm";
  strBoardheight2 = strBoardheight2+"cm";
}else if(valueBoard=="棚板1枚"){
  var numBoard1 = strBoardheight1;
  var numBoard2 = "0";
  strBoardheight1 = strBoardheight1+"cm";
  strBoardheight2="なし";
}else if(valueBoard=="棚板なし"){
  var numBoard1 = "0";
  var numBoard2 = "0";
  strBoardheight1="なし";
  strBoardheight2="なし";
}



document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=strDepth+"cm"
document.getElementById("choice3").value=strHeight+"cm"
document.getElementById("choice4").value=valueBoard
document.getElementById("choice5").value=strBoardheight1
document.getElementById("choice6").value=strBoardheight2
document.getElementById("choice7").value=valueColor
document.getElementById("choice8").value=valueOption
document.getElementById("choice10").value=total

//商品ページの有無チェック
var comcode=checkURL(strHaba,strDepth,strHeight,strThick,strColor,numBoard1,numBoard2);
if(!comcode=="" && valueOption=="オプション無し" && strColor!="kme"){
  if(valueColor=="オーク" || valueColor=="ブラックウッド"){
    var target=document.getElementById("linkmsg");
    linkmsg.style.visibility="visible";
    target.innerHTML=valueColor+"は別注色のため金額が異なります。";
  }
  else {
  var target=document.getElementById("linkmsg");
  linkmsg.style.visibility="visible";
  target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
  return false;
  }
}

/*2022/2/24以前
if (!comcode=="" && valueOption=="オプション無し" && strColor!="kme" && valueColor!=="オーク"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
if (!comcode=="" && valueOption=="オプション無し" && strColor!="kme" && valueColor=="オーク"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="リーズナブル木目オークは別注色のため金額が異なります。";
}*/

  
var url=searchURL(strHaba,strDepth,strHeight,strThick,strColor,numBoard1,numBoard2);

if(!url){
alert("サイズを入力してください");
return false;
}
//20191122追加
var strVisible=sizemsg.style.visibility;
if(document.getElementById("sizemsg").innerHTML == "<p>※ 棚板なしの高さ90cm以上をご希望の場合は、ボンドでの固定と壁付けにて設置でのご使用をお願いいたします ※</p>"){
    
}else if(strVisible!="hidden"){
alert("サイズの確認をお願いします");
return false;
}
if(!comcode=="" && valueOption!="オプション無し" && strColor!="kme"){
url=checkPrice(strHaba,strDepth,strHeight,strThick,strColor,numBoard1,numBoard2);
}
//var strCode=url.substr(url.lastIndexOf("/"));
//url=url.replace(strCode,"");
//strCode="/"+strCode.substring(4,11)

var intUnit;
if (isNaN(url)==false){
 intUnit=(parseInt(url)+total)/1000;
 document.getElementById("price").value =(parseInt(url)+total).toLocaleString()+" 円";
 cart_price.innerHTML =(parseInt(url)+total).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_depth.innerHTML=strDepth;
 cart_height.innerHTML=strHeight;
 cart_number.innerHTML=valueBoard;
 cart_board1.innerHTML=strBoardheight1;
 cart_board2.innerHTML=strBoardheight2;
 cart_color.innerHTML=valueColor;
 cart_option.innerHTML=valueOption;
 additional_fee.innerHTML=total;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice9").value="見積もり金額："+(parseInt(url)+total);
return false;
}

function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;
 var choice3=document.frm.choice3.value;  
 var choice4=document.frm.choice4.value;
 var choice5=document.frm.choice5.value;  
 var choice6=document.frm.choice6.value; 
 var choice7=document.frm.choice7.value;  
 var choice8=document.frm.choice8.value; 
 var choice10=document.frm.choice10.value; 
 var text = document.frm.inventory_id.value;
 var price = document.frm_detail.price.value;
 if(choice1=="" || choice2=="" || choice3=="" || choice5=="" || choice6=="") {
     alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
     return false;
 }
 if(price=="") {
     alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
     return false;
 }       
 return true;
}


goods = new Object();
goods[0] =new setGoods("0000a52633","90","25","40","40","wood","13","0","26000");
goods[1] =new setGoods("0000a52638","90","30","40","40","wood","13","0","28000");
goods[2] =new setGoods("0000a52643","90","35","40","40","wood","13","0","30000");
goods[3] =new setGoods("0000a52648","120","25","40","40","wood","13","0","31000");
goods[4] =new setGoods("0000a52653","120","30","40","40","wood","13","0","33000");
goods[5] =new setGoods("0000a52658","120","35","40","40","wood","13","0","35000");
goods[6] =new setGoods("0000a52663","150","25","40","40","wood","13","0","37000");
goods[7] =new setGoods("0000a52668","150","30","40","40","wood","13","0","39000");
goods[8] =new setGoods("0000a52673","150","35","40","40","wood","13","0","41000");
goods[9] =new setGoods("0000a52678","180","25","40","40","wood","13","0","42000");
goods[10] =new setGoods("0000a52683","180","30","40","40","wood","13","0","44000");
goods[11] =new setGoods("0000a52688","180","35","40","40","wood","13","0","46000");
goods[12] =new setGoods("0000a52693","90","25","60","40","wood","13","0","28000");
goods[13] =new setGoods("0000a52698","90","30","60","40","wood","13","0","30000");
goods[14] =new setGoods("0000a52703","90","35","60","40","wood","13","0","32000");
goods[15] =new setGoods("0000a52708","120","25","60","40","wood","13","0","33000");
goods[16] =new setGoods("0000a52713","120","30","60","40","wood","13","0","35000");
goods[17] =new setGoods("0000a52718","120","35","60","40","wood","13","0","37000");
goods[18] =new setGoods("0000a52723","150","25","60","40","wood","13","0","39000");
goods[19] =new setGoods("0000a52728","150","30","60","40","wood","13","0","41000");
goods[20] =new setGoods("0000a52733","150","35","60","40","wood","13","0","43000");
goods[21] =new setGoods("0000a52738","180","25","60","40","wood","13","0","44000");
goods[22] =new setGoods("0000a52743","180","30","60","40","wood","13","0","46000");
goods[23] =new setGoods("0000a52748","180","35","60","40","wood","13","0","48000");
goods[24] =new setGoods("0000a52753","90","25","70","40","wood","32","0","30000");
goods[25] =new setGoods("0000a52758","90","30","70","40","wood","32","0","32000");
goods[26] =new setGoods("0000a52763","90","35","70","40","wood","32","0","34000");
goods[27] =new setGoods("0000a52768","120","25","70","40","wood","32","0","35000");
goods[28] =new setGoods("0000a52773","120","30","70","40","wood","32","0","37000");
goods[29] =new setGoods("0000a52778","120","35","70","40","wood","32","0","39000");
goods[30] =new setGoods("0000a52783","150","25","70","40","wood","32","0","41000");
goods[31] =new setGoods("0000a52788","150","30","70","40","wood","32","0","43000");
goods[32] =new setGoods("0000a52793","150","35","70","40","wood","32","0","45000");
goods[33] =new setGoods("0000a52798","180","25","70","40","wood","32","0","46000");
goods[34] =new setGoods("0000a52803","180","30","70","40","wood","32","0","48000");
goods[35] =new setGoods("0000a52808","180","35","70","40","wood","32","0","51000");
goods[36] =new setGoods("0000a52813","90","25","90","40","wood","32","32","39000");
goods[37] =new setGoods("0000a52818","90","30","90","40","wood","32","32","41000");
goods[38] =new setGoods("0000a52823","90","35","90","40","wood","32","32","44000");
goods[39] =new setGoods("0000a52828","120","25","90","40","wood","32","32","46000");
goods[40] =new setGoods("0000a52833","120","30","90","40","wood","32","32","49000");
goods[41] =new setGoods("0000a52838","120","35","90","40","wood","32","32","52000");
goods[42] =new setGoods("0000a52843","150","25","90","40","wood","32","32","54000");
goods[43] =new setGoods("0000a52848","150","30","90","40","wood","32","32","57000");
goods[44] =new setGoods("0000a52853","150","35","90","40","wood","32","32","60000");
goods[45] =new setGoods("0000a52858","180","25","90","40","wood","32","32","62000");
goods[46] =new setGoods("0000a52863","180","30","90","40","wood","32","32","65000");
goods[47] =new setGoods("0000a52868","180","35","90","40","wood","32","32","68000");
goods[48] =new setGoods("0000a56068","90","25","40","40","nail","13","0","58300");
goods[49] =new setGoods("0000a56069","90","30","40","40","nail","13","0","58300");
goods[50] =new setGoods("0000a56070","90","35","40","40","nail","13","0","66000");
goods[51] =new setGoods("0000a56071","120","25","40","40","nail","13","0","69300");
goods[52] =new setGoods("0000a56072","120","30","40","40","nail","13","0","69300");
goods[53] =new setGoods("0000a56073","120","35","40","40","nail","13","0","81400");
goods[54] =new setGoods("0000a56074","150","25","40","40","nail","13","0","70400");
goods[55] =new setGoods("0000a56075","150","30","40","40","nail","13","0","70400");
goods[56] =new setGoods("0000a56076","150","35","40","40","nail","13","0","82500");
goods[57] =new setGoods("0000a56077","180","25","40","40","nail","13","0","71500");
goods[58] =new setGoods("0000a56078","180","30","40","40","nail","13","0","71500");
goods[59] =new setGoods("0000a56079","180","35","40","40","nail","13","0","83600");
goods[60] =new setGoods("0000a56080","90","25","60","40","nail","13","0","62700");
goods[61] =new setGoods("0000a56081","90","30","60","40","nail","13","0","62700");
goods[62] =new setGoods("0000a56082","90","35","60","40","nail","13","0","71500");
goods[63] =new setGoods("0000a56083","120","25","60","40","nail","13","0","73700");
goods[64] =new setGoods("0000a56084","120","30","60","40","nail","13","0","73700");
goods[65] =new setGoods("0000a56085","120","35","60","40","nail","13","0","86900");
goods[66] =new setGoods("0000a56086","150","25","60","40","nail","13","0","74800");
goods[67] =new setGoods("0000a56087","150","30","60","40","nail","13","0","74800");
goods[68] =new setGoods("0000a56088","150","35","60","40","nail","13","0","88000");
goods[69] =new setGoods("0000a56089","180","25","60","40","nail","13","0","75900");
goods[70] =new setGoods("0000a56090","180","30","60","40","nail","13","0","75900");
goods[71] =new setGoods("0000a56091","180","35","60","40","nail","13","0","89100");
goods[72] =new setGoods("0000a56092","90","25","70","40","nail","32","0","69300");
goods[73] =new setGoods("0000a56093","90","30","70","40","nail","32","0","69300");
goods[74] =new setGoods("0000a56094","90","35","70","40","nail","32","0","79200");
goods[75] =new setGoods("0000a56095","120","25","70","40","nail","32","0","80300");
goods[76] =new setGoods("0000a56096","120","30","70","40","nail","32","0","80300");
goods[77] =new setGoods("0000a56097","120","35","70","40","nail","32","0","94600");
goods[78] =new setGoods("0000a56098","150","25","70","40","nail","32","0","81400");
goods[79] =new setGoods("0000a56099","150","30","70","40","nail","32","0","81400");
goods[80] =new setGoods("0000a56100","150","35","70","40","nail","32","0","95700");
goods[81] =new setGoods("0000a56101","180","25","70","40","nail","32","0","82500");
goods[82] =new setGoods("0000a56102","180","30","70","40","nail","32","0","82500");
goods[83] =new setGoods("0000a56103","180","35","70","40","nail","32","0","96800");
goods[84] =new setGoods("0000a56104","90","25","90","40","nail","32","32","88000");
goods[85] =new setGoods("0000a56105","90","30","90","40","nail","32","32","88000");
goods[86] =new setGoods("0000a56106","90","35","90","40","nail","32","32","100100");
goods[87] =new setGoods("0000a56107","120","25","90","40","nail","32","32","103400");
goods[88] =new setGoods("0000a56108","120","30","90","40","nail","32","32","103400");
goods[89] =new setGoods("0000a56109","120","35","90","40","nail","32","32","123200");
goods[90] =new setGoods("0000a56110","150","25","90","40","nail","32","32","105600");
goods[91] =new setGoods("0000a56111","150","30","90","40","nail","32","32","105600");
goods[92] =new setGoods("0000a56112","150","35","90","40","nail","32","32","124300");
goods[93] =new setGoods("0000a56113","180","25","90","40","nail","32","32","106700");
goods[94] =new setGoods("0000a56114","180","30","90","40","nail","32","32","106700");
goods[95] =new setGoods("0000a56115","180","35","90","40","nail","32","32","126500");
goods[96] =new setGoods("0000a56116","90","25","40","40","black","13","0","58300");
goods[97] =new setGoods("0000a56117","90","30","40","40","black","13","0","58300");
goods[98] =new setGoods("0000a56118","90","35","40","40","black","13","0","66000");
goods[99] =new setGoods("0000a56119","120","25","40","40","black","13","0","69300");
goods[100] =new setGoods("0000a56120","120","30","40","40","black","13","0","69300");
goods[101] =new setGoods("0000a56121","120","35","40","40","black","13","0","81400");
goods[102] =new setGoods("0000a56122","150","25","40","40","black","13","0","70400");
goods[103] =new setGoods("0000a56123","150","30","40","40","black","13","0","70400");
goods[104] =new setGoods("0000a56124","150","35","40","40","black","13","0","82500");
goods[105] =new setGoods("0000a56125","180","25","40","40","black","13","0","71500");
goods[106] =new setGoods("0000a56126","180","30","40","40","black","13","0","71500");
goods[107] =new setGoods("0000a56127","180","35","40","40","black","13","0","83600");
goods[108] =new setGoods("0000a56128","90","25","60","40","black","13","0","62700");
goods[109] =new setGoods("0000a56129","90","30","60","40","black","13","0","62700");
goods[110] =new setGoods("0000a56130","90","35","60","40","black","13","0","71500");
goods[111] =new setGoods("0000a56131","120","25","60","40","black","13","0","73700");
goods[112] =new setGoods("0000a56132","120","30","60","40","black","13","0","73700");
goods[113] =new setGoods("0000a56133","120","35","60","40","black","13","0","86900");
goods[114] =new setGoods("0000a56134","150","25","60","40","black","13","0","74800");
goods[115] =new setGoods("0000a56135","150","30","60","40","black","13","0","74800");
goods[116] =new setGoods("0000a56136","150","35","60","40","black","13","0","88000");
goods[117] =new setGoods("0000a56137","180","25","60","40","black","13","0","75900");
goods[118] =new setGoods("0000a56138","180","30","60","40","black","13","0","75900");
goods[119] =new setGoods("0000a56139","180","35","60","40","black","13","0","89100");
goods[120] =new setGoods("0000a56140","90","25","70","40","black","32","0","69300");
goods[121] =new setGoods("0000a56141","90","30","70","40","black","32","0","69300");
goods[122] =new setGoods("0000a56142","90","35","70","40","black","32","0","79200");
goods[123] =new setGoods("0000a56143","120","25","70","40","black","32","0","80300");
goods[124] =new setGoods("0000a56144","120","30","70","40","black","32","0","80300");
goods[125] =new setGoods("0000a56145","120","35","70","40","black","32","0","94600");
goods[126] =new setGoods("0000a56146","150","25","70","40","black","32","0","81400");
goods[127] =new setGoods("0000a56147","150","30","70","40","black","32","0","81400");
goods[128] =new setGoods("0000a56148","150","35","70","40","black","32","0","95700");
goods[129] =new setGoods("0000a56149","180","25","70","40","black","32","0","82500");
goods[130] =new setGoods("0000a56150","180","30","70","40","black","32","0","82500");
goods[131] =new setGoods("0000a56151","180","35","70","40","black","32","0","96800");
goods[132] =new setGoods("0000a56152","90","25","90","40","black","32","32","88000");
goods[133] =new setGoods("0000a56153","90","30","90","40","black","32","32","88000");
goods[134] =new setGoods("0000a56154","90","35","90","40","black","32","32","100100");
goods[135] =new setGoods("0000a56155","120","25","90","40","black","32","32","103400");
goods[136] =new setGoods("0000a56156","120","30","90","40","black","32","32","103400");
goods[137] =new setGoods("0000a56157","120","35","90","40","black","32","32","123200");
goods[138] =new setGoods("0000a56158","150","25","90","40","black","32","32","105600");
goods[139] =new setGoods("0000a56159","150","30","90","40","black","32","32","105600");
goods[140] =new setGoods("0000a56160","150","35","90","40","black","32","32","124300");
goods[141] =new setGoods("0000a56161","180","25","90","40","black","32","32","106700");
goods[142] =new setGoods("0000a56162","180","30","90","40","black","32","32","106700");
goods[143] =new setGoods("0000a56163","180","35","90","40","black","32","32","126500");
goods[144] =new setGoods("0000a56164","90","25","40","40","bp","13","0","67100");
goods[145] =new setGoods("0000a56165","90","30","40","40","bp","13","0","67100");
goods[146] =new setGoods("0000a56166","90","35","40","40","bp","13","0","77000");
goods[147] =new setGoods("0000a56167","120","25","40","40","bp","13","0","81400");
goods[148] =new setGoods("0000a56168","120","30","40","40","bp","13","0","81400");
goods[149] =new setGoods("0000a56169","120","35","40","40","bp","13","0","97900");
goods[150] =new setGoods("0000a56170","150","25","40","40","bp","13","0","83600");
goods[151] =new setGoods("0000a56171","150","30","40","40","bp","13","0","83600");
goods[152] =new setGoods("0000a56172","150","35","40","40","bp","13","0","99000");
goods[153] =new setGoods("0000a56173","180","25","40","40","bp","13","0","84700");
goods[154] =new setGoods("0000a56174","180","30","40","40","bp","13","0","85800");
goods[155] =new setGoods("0000a56175","180","35","40","40","bp","13","0","101200");
goods[156] =new setGoods("0000a56176","90","25","60","40","bp","13","0","72600");
goods[157] =new setGoods("0000a56177","90","30","60","40","bp","13","0","72600");
goods[158] =new setGoods("0000a56178","90","35","60","40","bp","13","0","82500");
goods[159] =new setGoods("0000a56179","120","25","60","40","bp","13","0","86900");
goods[160] =new setGoods("0000a56180","120","30","60","40","bp","13","0","86900");
goods[161] =new setGoods("0000a56181","120","35","60","40","bp","13","0","103400");
goods[162] =new setGoods("0000a56182","150","25","60","40","bp","13","0","88000");
goods[163] =new setGoods("0000a56183","150","30","60","40","bp","13","0","89100");
goods[164] =new setGoods("0000a56184","150","35","60","40","bp","13","0","105600");
goods[165] =new setGoods("0000a56185","180","25","60","40","bp","13","0","90200");
goods[166] =new setGoods("0000a56186","180","30","60","40","bp","13","0","90200");
goods[167] =new setGoods("0000a56187","180","35","60","40","bp","13","0","107800");
goods[168] =new setGoods("0000a56188","90","25","70","40","bp","32","0","80300");
goods[169] =new setGoods("0000a56189","90","30","70","40","bp","32","0","80300");
goods[170] =new setGoods("0000a56190","90","35","70","40","bp","32","0","92400");
goods[171] =new setGoods("0000a56191","120","25","70","40","bp","32","0","94600");
goods[172] =new setGoods("0000a56192","120","30","70","40","bp","32","0","94600");
goods[173] =new setGoods("0000a56193","120","35","70","40","bp","32","0","113300");
goods[174] =new setGoods("0000a56194","150","25","70","40","bp","32","0","95700");
goods[175] =new setGoods("0000a56195","150","30","70","40","bp","32","0","96800");
goods[176] =new setGoods("0000a56196","150","35","70","40","bp","32","0","115500");
goods[177] =new setGoods("0000a56197","180","25","70","40","bp","32","0","97900");
goods[178] =new setGoods("0000a56198","180","30","70","40","bp","32","0","97900");
goods[179] =new setGoods("0000a56199","180","35","70","40","bp","32","0","117700");
goods[180] =new setGoods("0000a56200","90","25","90","40","bp","32","32","101200");
goods[181] =new setGoods("0000a56201","90","30","90","40","bp","32","32","101200");
goods[182] =new setGoods("0000a56202","90","35","90","40","bp","32","32","117700");
goods[183] =new setGoods("0000a56203","120","25","90","40","bp","32","32","123200");
goods[184] =new setGoods("0000a56204","120","30","90","40","bp","32","32","123200");
goods[185] =new setGoods("0000a56205","120","35","90","40","bp","32","32","148500");
goods[186] =new setGoods("0000a56206","150","25","90","40","bp","32","32","125400");
goods[187] =new setGoods("0000a56207","150","30","90","40","bp","32","32","126500");
goods[188] =new setGoods("0000a56208","150","35","90","40","bp","32","32","150700");
goods[189] =new setGoods("0000a56209","180","25","90","40","bp","32","32","128700");
goods[190] =new setGoods("0000a56210","180","30","90","40","bp","32","32","128700");
goods[191] =new setGoods("0000a56211","180","35","90","40","bp","32","32","154000");
goods[192] =new setGoods("0000a56212","90","25","40","40","mb","13","0","71500");
goods[193] =new setGoods("0000a56213","90","30","40","40","mb","13","0","71500");
goods[194] =new setGoods("0000a56214","90","35","40","40","mb","13","0","83600");
goods[195] =new setGoods("0000a56215","120","25","40","40","mb","13","0","89100");
goods[196] =new setGoods("0000a56216","120","30","40","40","mb","13","0","89100");
goods[197] =new setGoods("0000a56217","120","35","40","40","mb","13","0","107800");
goods[198] =new setGoods("0000a56218","150","25","40","40","mb","13","0","90200");
goods[199] =new setGoods("0000a56219","150","30","40","40","mb","13","0","91300");
goods[200] =new setGoods("0000a56220","150","35","40","40","mb","13","0","110000");
goods[201] =new setGoods("0000a56221","180","25","40","40","mb","13","0","92400");
goods[202] =new setGoods("0000a56222","180","30","40","40","mb","13","0","92400");
goods[203] =new setGoods("0000a56223","180","35","40","40","mb","13","0","112200");
goods[204] =new setGoods("0000a56224","90","25","60","40","mb","13","0","77000");
goods[205] =new setGoods("0000a56225","90","30","60","40","mb","13","0","77000");
goods[206] =new setGoods("0000a56226","90","35","60","40","mb","13","0","90200");
goods[207] =new setGoods("0000a56227","120","25","60","40","mb","13","0","94600");
goods[208] =new setGoods("0000a56228","120","30","60","40","mb","13","0","94600");
goods[209] =new setGoods("0000a56229","120","35","60","40","mb","13","0","115500");
goods[210] =new setGoods("0000a56230","150","25","60","40","mb","13","0","96800");
goods[211] =new setGoods("0000a56231","150","30","60","40","mb","13","0","96800");
goods[212] =new setGoods("0000a56232","150","35","60","40","mb","13","0","116600");
goods[213] =new setGoods("0000a56233","180","25","60","40","mb","13","0","97900");
goods[214] =new setGoods("0000a56234","180","30","60","40","mb","13","0","97900");
goods[215] =new setGoods("0000a56235","180","35","60","40","mb","13","0","118800");
goods[216] =new setGoods("0000a56236","90","25","70","40","mb","32","0","85800");
goods[217] =new setGoods("0000a56237","90","30","70","40","mb","32","0","85800");
goods[218] =new setGoods("0000a56238","90","35","70","40","mb","32","0","101200");
goods[219] =new setGoods("0000a56239","120","25","70","40","mb","32","0","103400");
goods[220] =new setGoods("0000a56240","120","30","70","40","mb","32","0","103400");
goods[221] =new setGoods("0000a56241","120","35","70","40","mb","32","0","126500");
goods[222] =new setGoods("0000a56242","150","25","70","40","mb","32","0","104500");
goods[223] =new setGoods("0000a56243","150","30","70","40","mb","32","0","105600");
goods[224] =new setGoods("0000a56244","150","35","70","40","mb","32","0","128700");
goods[225] =new setGoods("0000a56245","180","25","70","40","mb","32","0","106700");
goods[226] =new setGoods("0000a56246","180","30","70","40","mb","32","0","106700");
goods[227] =new setGoods("0000a56247","180","35","70","40","mb","32","0","129800");
goods[228] =new setGoods("0000a56248","90","25","90","40","mb","32","32","108900");
goods[229] =new setGoods("0000a56249","90","30","90","40","mb","32","32","108900");
goods[230] =new setGoods("0000a56250","90","35","90","40","mb","32","32","128700");
goods[231] =new setGoods("0000a56251","120","25","90","40","mb","32","32","134200");
goods[232] =new setGoods("0000a56252","120","30","90","40","mb","32","32","135300");
goods[233] =new setGoods("0000a56253","120","35","90","40","mb","32","32","166100");
goods[234] =new setGoods("0000a56254","150","25","90","40","mb","32","32","137500");
goods[235] =new setGoods("0000a56255","150","30","90","40","mb","32","32","137500");
goods[236] =new setGoods("0000a56256","150","35","90","40","mb","32","32","168300");
goods[237] =new setGoods("0000a56257","180","25","90","40","mb","32","32","140800");
goods[238] =new setGoods("0000a56258","180","30","90","40","mb","32","32","140800");
goods[239] =new setGoods("0000a56259","180","35","90","40","mb","32","32","171600");
goods[240] =new setGoods("0000a56260","90","25","40","40","gs","13","0","71500");
goods[241] =new setGoods("0000a56261","90","30","40","40","gs","13","0","71500");
goods[242] =new setGoods("0000a56262","90","35","40","40","gs","13","0","83600");
goods[243] =new setGoods("0000a56263","120","25","40","40","gs","13","0","89100");
goods[244] =new setGoods("0000a56264","120","30","40","40","gs","13","0","89100");
goods[245] =new setGoods("0000a56265","120","35","40","40","gs","13","0","107800");
goods[246] =new setGoods("0000a56266","150","25","40","40","gs","13","0","90200");
goods[247] =new setGoods("0000a56267","150","30","40","40","gs","13","0","91300");
goods[248] =new setGoods("0000a56268","150","35","40","40","gs","13","0","110000");
goods[249] =new setGoods("0000a56269","180","25","40","40","gs","13","0","92400");
goods[250] =new setGoods("0000a56270","180","30","40","40","gs","13","0","92400");
goods[251] =new setGoods("0000a56271","180","35","40","40","gs","13","0","112200");
goods[252] =new setGoods("0000a56272","90","25","60","40","gs","13","0","77000");
goods[253] =new setGoods("0000a56273","90","30","60","40","gs","13","0","77000");
goods[254] =new setGoods("0000a56274","90","35","60","40","gs","13","0","90200");
goods[255] =new setGoods("0000a56275","120","25","60","40","gs","13","0","94600");
goods[256] =new setGoods("0000a56276","120","30","60","40","gs","13","0","94600");
goods[257] =new setGoods("0000a56277","120","35","60","40","gs","13","0","115500");
goods[258] =new setGoods("0000a56278","150","25","60","40","gs","13","0","96800");
goods[259] =new setGoods("0000a56279","150","30","60","40","gs","13","0","96800");
goods[260] =new setGoods("0000a56280","150","35","60","40","gs","13","0","116600");
goods[261] =new setGoods("0000a56281","180","25","60","40","gs","13","0","97900");
goods[262] =new setGoods("0000a56282","180","30","60","40","gs","13","0","97900");
goods[263] =new setGoods("0000a56283","180","35","60","40","gs","13","0","118800");
goods[264] =new setGoods("0000a56284","90","25","70","40","gs","32","0","85800");
goods[265] =new setGoods("0000a56285","90","30","70","40","gs","32","0","85800");
goods[266] =new setGoods("0000a56286","90","35","70","40","gs","32","0","101200");
goods[267] =new setGoods("0000a56287","120","25","70","40","gs","32","0","103400");
goods[268] =new setGoods("0000a56288","120","30","70","40","gs","32","0","103400");
goods[269] =new setGoods("0000a56289","120","35","70","40","gs","32","0","126500");
goods[270] =new setGoods("0000a56290","150","25","70","40","gs","32","0","104500");
goods[271] =new setGoods("0000a56291","150","30","70","40","gs","32","0","105600");
goods[272] =new setGoods("0000a56292","150","35","70","40","gs","32","0","128700");
goods[273] =new setGoods("0000a56293","180","25","70","40","gs","32","0","106700");
goods[274] =new setGoods("0000a56294","180","30","70","40","gs","32","0","106700");
goods[275] =new setGoods("0000a56295","180","35","70","40","gs","32","0","129800");
goods[276] =new setGoods("0000a56296","90","25","90","40","gs","32","32","108900");
goods[277] =new setGoods("0000a56297","90","30","90","40","gs","32","32","108900");
goods[278] =new setGoods("0000a56298","90","35","90","40","gs","32","32","128700");
goods[279] =new setGoods("0000a56299","120","25","90","40","gs","32","32","134200");
goods[280] =new setGoods("0000a56300","120","30","90","40","gs","32","32","135300");
goods[281] =new setGoods("0000a56301","120","35","90","40","gs","32","32","166100");
goods[282] =new setGoods("0000a56302","150","25","90","40","gs","32","32","137500");
goods[283] =new setGoods("0000a56303","150","30","90","40","gs","32","32","137500");
goods[284] =new setGoods("0000a56304","150","35","90","40","gs","32","32","168300");
goods[285] =new setGoods("0000a56305","180","25","90","40","gs","32","32","140800");
goods[286] =new setGoods("0000a56306","180","30","90","40","gs","32","32","140800");
goods[287] =new setGoods("0000a56307","180","35","90","40","gs","32","32","171600");
goods[288] =new setGoods("0000a56308","90","25","40","40","ww","13","0","71500");
goods[289] =new setGoods("0000a56309","90","30","40","40","ww","13","0","71500");
goods[290] =new setGoods("0000a56310","90","35","40","40","ww","13","0","83600");
goods[291] =new setGoods("0000a56311","120","25","40","40","ww","13","0","89100");
goods[292] =new setGoods("0000a56312","120","30","40","40","ww","13","0","89100");
goods[293] =new setGoods("0000a56313","120","35","40","40","ww","13","0","107800");
goods[294] =new setGoods("0000a56314","150","25","40","40","ww","13","0","90200");
goods[295] =new setGoods("0000a56315","150","30","40","40","ww","13","0","91300");
goods[296] =new setGoods("0000a56316","150","35","40","40","ww","13","0","110000");
goods[297] =new setGoods("0000a56317","180","25","40","40","ww","13","0","92400");
goods[298] =new setGoods("0000a56318","180","30","40","40","ww","13","0","92400");
goods[299] =new setGoods("0000a56319","180","35","40","40","ww","13","0","112200");
goods[300] =new setGoods("0000a56320","90","25","60","40","ww","13","0","77000");
goods[301] =new setGoods("0000a56321","90","30","60","40","ww","13","0","77000");
goods[302] =new setGoods("0000a56322","90","35","60","40","ww","13","0","90200");
goods[303] =new setGoods("0000a56323","120","25","60","40","ww","13","0","94600");
goods[304] =new setGoods("0000a56324","120","30","60","40","ww","13","0","94600");
goods[305] =new setGoods("0000a56325","120","35","60","40","ww","13","0","115500");
goods[306] =new setGoods("0000a56326","150","25","60","40","ww","13","0","96800");
goods[307] =new setGoods("0000a56327","150","30","60","40","ww","13","0","96800");
goods[308] =new setGoods("0000a56328","150","35","60","40","ww","13","0","116600");
goods[309] =new setGoods("0000a56329","180","25","60","40","ww","13","0","97900");
goods[310] =new setGoods("0000a56330","180","30","60","40","ww","13","0","97900");
goods[311] =new setGoods("0000a56331","180","35","60","40","ww","13","0","118800");
goods[312] =new setGoods("0000a56332","90","25","70","40","ww","32","0","85800");
goods[313] =new setGoods("0000a56333","90","30","70","40","ww","32","0","85800");
goods[314] =new setGoods("0000a56334","90","35","70","40","ww","32","0","101200");
goods[315] =new setGoods("0000a56335","120","25","70","40","ww","32","0","103400");
goods[316] =new setGoods("0000a56336","120","30","70","40","ww","32","0","103400");
goods[317] =new setGoods("0000a56337","120","35","70","40","ww","32","0","126500");
goods[318] =new setGoods("0000a56338","150","25","70","40","ww","32","0","104500");
goods[319] =new setGoods("0000a56339","150","30","70","40","ww","32","0","105600");
goods[320] =new setGoods("0000a56340","150","35","70","40","ww","32","0","128700");
goods[321] =new setGoods("0000a56341","180","25","70","40","ww","32","0","106700");
goods[322] =new setGoods("0000a56342","180","30","70","40","ww","32","0","106700");
goods[323] =new setGoods("0000a56343","180","35","70","40","ww","32","0","129800");
goods[324] =new setGoods("0000a56344","90","25","90","40","ww","32","32","108900");
goods[325] =new setGoods("0000a56345","90","30","90","40","ww","32","32","108900");
goods[326] =new setGoods("0000a56346","90","35","90","40","ww","32","32","128700");
goods[327] =new setGoods("0000a56347","120","25","90","40","ww","32","32","134200");
goods[328] =new setGoods("0000a56348","120","30","90","40","ww","32","32","135300");
goods[329] =new setGoods("0000a56349","120","35","90","40","ww","32","32","166100");
goods[330] =new setGoods("0000a56350","150","25","90","40","ww","32","32","137500");
goods[331] =new setGoods("0000a56351","150","30","90","40","ww","32","32","137500");
goods[332] =new setGoods("0000a56352","150","35","90","40","ww","32","32","168300");
goods[333] =new setGoods("0000a56353","180","25","90","40","ww","32","32","140800");
goods[334] =new setGoods("0000a56354","180","30","90","40","ww","32","32","140800");
goods[335] =new setGoods("0000a56355","180","35","90","40","ww","32","32","171600");
goods[336] =new setGoods("未登録","90","25","40","40","kme","13","0","128000");
goods[337] =new setGoods("未登録","90","30","40","40","kme","13","0","128000");
goods[338] =new setGoods("未登録","90","35","40","40","kme","13","0","128000");
goods[339] =new setGoods("未登録","120","25","40","40","kme","13","0","137000");
goods[340] =new setGoods("未登録","120","30","40","40","kme","13","0","137000");
goods[341] =new setGoods("未登録","120","35","40","40","kme","13","0","137000");
goods[342] =new setGoods("未登録","150","25","40","40","kme","13","0","146000");
goods[343] =new setGoods("未登録","150","30","40","40","kme","13","0","146000");
goods[344] =new setGoods("未登録","150","35","40","40","kme","13","0","146000");
goods[345] =new setGoods("未登録","180","25","40","40","kme","13","0","155000");
goods[346] =new setGoods("未登録","180","30","40","40","kme","13","0","155000");
goods[347] =new setGoods("未登録","180","35","40","40","kme","13","0","155000");
goods[348] =new setGoods("未登録","90","25","60","40","kme","13","0","139000");
goods[349] =new setGoods("未登録","90","30","60","40","kme","13","0","139000");
goods[350] =new setGoods("未登録","90","35","60","40","kme","13","0","139000");
goods[351] =new setGoods("未登録","120","25","60","40","kme","13","0","148000");
goods[352] =new setGoods("未登録","120","30","60","40","kme","13","0","148000");
goods[353] =new setGoods("未登録","120","35","60","40","kme","13","0","148000");
goods[354] =new setGoods("未登録","150","25","60","40","kme","13","0","157000");
goods[355] =new setGoods("未登録","150","30","60","40","kme","13","0","157000");
goods[356] =new setGoods("未登録","150","35","60","40","kme","13","0","157000");
goods[357] =new setGoods("未登録","180","25","60","40","kme","13","0","166000");
goods[358] =new setGoods("未登録","180","30","60","40","kme","13","0","166000");
goods[359] =new setGoods("未登録","180","35","60","40","kme","13","0","166000");
goods[360] =new setGoods("未登録","90","25","70","40","kme","32","0","147000");
goods[361] =new setGoods("未登録","90","30","70","40","kme","32","0","147000");
goods[362] =new setGoods("未登録","90","35","70","40","kme","32","0","147000");
goods[363] =new setGoods("未登録","120","25","70","40","kme","32","0","156000");
goods[364] =new setGoods("未登録","120","30","70","40","kme","32","0","156000");
goods[365] =new setGoods("未登録","120","35","70","40","kme","32","0","156000");
goods[366] =new setGoods("未登録","150","25","70","40","kme","32","0","165000");
goods[367] =new setGoods("未登録","150","30","70","40","kme","32","0","165000");
goods[368] =new setGoods("未登録","150","35","70","40","kme","32","0","165000");
goods[369] =new setGoods("未登録","180","25","70","40","kme","32","0","174000");
goods[370] =new setGoods("未登録","180","30","70","40","kme","32","0","174000");
goods[371] =new setGoods("未登録","180","35","70","40","kme","32","0","174000");
goods[372] =new setGoods("未登録","90","25","90","40","kme","32","32","194000");
goods[373] =new setGoods("未登録","90","30","90","40","kme","32","32","194000");
goods[374] =new setGoods("未登録","90","35","90","40","kme","32","32","194000");
goods[375] =new setGoods("未登録","120","25","90","40","kme","32","32","203000");
goods[376] =new setGoods("未登録","120","30","90","40","kme","32","32","203000");
goods[377] =new setGoods("未登録","120","35","90","40","kme","32","32","203000");
goods[378] =new setGoods("未登録","150","25","90","40","kme","32","32","212000");
goods[379] =new setGoods("未登録","150","30","90","40","kme","32","32","212000");
goods[380] =new setGoods("未登録","150","35","90","40","kme","32","32","212000");
goods[381] =new setGoods("未登録","180","25","90","40","kme","32","32","221000");
goods[382] =new setGoods("未登録","180","30","90","40","kme","32","32","221000");
goods[383] =new setGoods("未登録","180","35","90","40","kme","32","32","221000");